import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  Form,
  FormFeedback,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";
import withRouter from "Components/Common/withRouter";

import { Link } from "react-router-dom";

// import images
import profileImg from "../../assets/images/profile-img.png";
import logoImg from "../../assets/images/logoDitoDark.svg";
import { createSelector } from "reselect";

//fakeData
import { registerEntity } from "slices/auth/registerEntity/thunk";
import {
  createPublicToken,
  getCurrencyType,
  getEconomicActivities,
  getEntityType,
  getLanguages,
  getPublicCountries,
  getStatesByCountry,
  logOutUser,
} from "../../helpers/dataBackend";
import { parseInt } from "lodash";
import { setAuthorization } from "../../helpers/api_helper";
import LanguageDropdown from "Components/Common/LanguageDropdown";
import { decryptDataResponse } from "shared/encryptInfo";
import { RootState } from "slices";

const EntityForm = (props: any) => {
  //meta title
  document.title = "Entity Register";

  const countryCodes = [
    { id: 1, abbr3: "USA", code: "+1" },
    { id: 2, abbr3: "CAN", code: "+1" },
    { id: 3, abbr3: "MEX", code: "+52" },
    { id: 4, abbr3: "ESP", code: "+34" },
    { id: 5, abbr3: "SLV", code: "+503" },
    { id: 6, abbr3: "GTM", code: "+502" },
    { id: 7, abbr3: "HND", code: "+504" },
    { id: 8, abbr3: "CRI", code: "+506" },
    { id: 9, abbr3: "PAN", code: "+507" },
    { id: 10, abbr3: "COL", code: "+57" },
    { id: 11, abbr3: "ARG", code: "+54" },
    { id: 12, abbr3: "BRA", code: "+55" },
    { id: 13, abbr3: "CHL", code: "+56" },
    { id: 14, abbr3: "PER", code: "+51" },
    { id: 15, abbr3: "VEN", code: "+58" },
    { id: 16, abbr3: "DEU", code: "+49" },
    { id: 17, abbr3: "FRA", code: "+33" },
    { id: 18, abbr3: "GBR", code: "+44" },
    { id: 19, abbr3: "ITA", code: "+39" },
    { id: 20, abbr3: "CHN", code: "+86" },
    { id: 21, abbr3: "JPN", code: "+81" },
    { id: 22, abbr3: "IND", code: "+91" },
    { id: 23, abbr3: "KOR", code: "+82" },
    { id: 24, abbr3: "AUS", code: "+61" },
    { id: 25, abbr3: "ZAF", code: "+27" },
  ];

  const [entityType, setEntityType] = useState<any>([]);
  const [currenType, setCurrenType] = useState<any>([]);
  const [stateCountry, setStateCountry] = useState<any>([]);
  const [countryType, setCountryType] = useState<any>([]);
  const [languageType, setLanguageType] = useState<any>([]);
  const [economicActivity, setEconomicActivity] = useState<any>([]);
  const [userType, setUserType] = useState<any>(0);
  const dispatch = useDispatch<any>();

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      social_number: "", // TODO - Cambiar por Numero de indentificacion tributaria
      numero_documento: "",
      nrc: "", // TODO - Este campo desaparece
      phone: 0,
      commercial_name: "",
      email: "",
      country: "",
      enabled: "",
      status_id: "",
      currency_id: "",
      state_country: "",
      language_id: "",
      entity_type_id: "",
      economic_activities: "",
      address: "",
    },
    validationSchema: Yup.object({
      social_number: Yup.string().required(
        "Please Enter Your Identification Number"
      ),
      numero_documento: Yup.string().required(
        "Please Enter Your Document Number"
      ),
      nrc: Yup.string().optional(),
      phone: Yup.number().required("Please Enter Your Phone number"),
      commercial_name: Yup.string().required(
        "Please Enter Your Commercial Name"
      ),
      email: Yup.string()
        .matches(emailRegex, "Por favor, ingresa un email válido")
        .required("Please Enter Your Email"),
      country: Yup.string().required("Please Enter Your country"),
      currency_id: Yup.number().required("Please Enter Your Currency"),
      state_country: Yup.number().required("Please Enter Your Country"),
      language_id: Yup.number().required("Please Enter Your Language"),
      entity_type_id: Yup.number().required("Please Enter Your Entity Type"),
      economic_activities: Yup.number().required(
        "Please Enter Your Economic Activity"
      ),
      address: Yup.string().required("Please Enter Your Address"),
    }),
    onSubmit: (values) => {
      const entityData: any = {
        social_number: values.social_number,
        numero_documento: values.numero_documento,
        nrc: values.nrc,
        phone: String(values.phone), //TODO - ver que se envie en formato String
        commercial_name: values.commercial_name,
        email: values.email,
        enabled: true,
        status_id: 1,
        currency_id: parseInt(values.currency_id),
        state_country_id: parseInt(values.state_country),
        language_id: parseInt(values.language_id),
        entity_type_id: parseInt(values.entity_type_id),
        economic_activity: parseInt(values.economic_activities),
        kyc_status_id: 1,
        address: values.address,
      };
      dispatch(registerEntity(entityData, props.router.navigate));
    },
  });

  const { registrationError } = useSelector((state: RootState) => state.Entity);

  const validateLocalStorage = () => {
    const token = localStorage.getItem("authUser");
    setAuthorization(token);
    if (localStorage.getItem("authUser")) {
      logOutUser();
      localStorage.clear();
    }
  };

  useEffect(() => {
    validateLocalStorage();
    console.log(
      JSON.parse(
        decryptDataResponse(
          "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"
        )
      )
    );
    const fetchData = async () => {
      try {
        const responsePublicToken = await createPublicToken();
        localStorage.setItem("publicToken", responsePublicToken.token);
        setAuthorization(responsePublicToken.token); // Guardar el token antes de continuar
        // console.log("Token creado:", responsePublicToken.token);
        // Ahora que el token está listo, hacer las demás llamadas
        const entity_type = await getEntityType();
        setEntityType(entity_type);

        const country_type = await getPublicCountries();
        setCountryType(country_type);

        const language = await getLanguages();
        setLanguageType(language);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };

    fetchData();
  }, [dispatch]);

  const handleApisCalls = async (countryAcronym: string) => {
    // console.log(countryAcronym);
    const curren_type = await getCurrencyType(countryAcronym);
    setCurrenType(curren_type);
    const state_country = await getStatesByCountry(countryAcronym);
    setStateCountry(state_country);
    const economic_activity = await getEconomicActivities(countryAcronym);
    setEconomicActivity(economic_activity);
  };

  return (
    <React.Fragment>
      <div className="account-pages pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={9} xl={10}>
              <Card className="overflow-hidden">
                <div
                  className="bg-primary-subtle"
                  // style={{ height: 200 + "px" }}
                >
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Entidad</h5>
                        <p>
                          Este formulario es para registrar la Entidad
                          correspondiente en la plataforma.
                        </p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img
                        src={profileImg}
                        alt=""
                        className="img-fluid"
                        style={{ width: 80 + "%" }}
                      />
                    </Col>
                  </Row>
                </div>
                {/* TODO - se coloco  aca */}
                <div
                  style={{ position: "absolute", right: "10px", top: "10px" }}
                >
                  <LanguageDropdown />
                </div>

                {/* CUERPO DEL FORMULARIO */}
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded bg-light">
                          <img src={logoImg} alt="" height="34" />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="d-flex justify-content-between">
                    <h4>Registro de entidad</h4>
                    <p>Step 1/3</p>
                  </div>
                  <hr />
                  <Form
                    className="form-horizontal"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    {registrationError && registrationError ? (
                      <Alert color="danger">{registrationError}</Alert>
                    ) : null}

                    <Row>
                      {/* COMIENZA LA COLUMNA DE LA IZQUIERDA */}
                      <Col sm={6}>
                        {/* entity_type_id esto moverlo arriba*/}
                        <div className="mb-3">
                          <Label className="form-label">Tipo de Usuario</Label>
                          <Input
                            type="select"
                            name="entity_type_id"
                            onChange={(e) => {
                              validation.handleChange(e);
                              setUserType(e.target.value);
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.entity_type_id || ""}
                            invalid={
                              validation.touched.entity_type_id &&
                              validation.errors.entity_type_id
                                ? true
                                : false
                            }
                          >
                            <option value="" selected disabled>
                              Select Entity Type
                            </option>
                            {entityType.map((entity: any) => (
                              <option key={entity.id} value={entity.id}>
                                {entity.name}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.entity_type_id &&
                            validation.errors.entity_type_id && (
                              <FormFeedback>
                                {validation.errors.entity_type_id}
                              </FormFeedback>
                            )}
                        </div>
                        {/* commercial_name */}
                        <div className="mb-3">
                          <Label className="form-label">Nombre Comercial</Label>
                          <Input
                            name="commercial_name"
                            type="text"
                            placeholder="Enter Commercial name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.commercial_name || ""}
                            invalid={
                              validation.touched.commercial_name &&
                              validation.errors.commercial_name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.commercial_name &&
                            validation.errors.commercial_name && (
                              <FormFeedback>
                                {validation.errors.commercial_name}
                              </FormFeedback>
                            )}
                        </div>

                        {/* TODO - Se agrega este nuevo campo para especificar el nombre de la personas juridica/natural */}
                        {/* commercial_name */}
                        <div className="mb-3">
                          <Label className="form-label">
                            Nombre persona Juridica/Natural
                          </Label>
                          <Input
                            name="commercial_name"
                            type="text"
                            placeholder="Enter legal/natural person name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.commercial_name || ""}
                            invalid={
                              validation.touched.commercial_name &&
                              validation.errors.commercial_name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.commercial_name &&
                            validation.errors.commercial_name && (
                              <FormFeedback>
                                {validation.errors.commercial_name}
                              </FormFeedback>
                            )}
                        </div>

                        {/* numero_documento */}
                        <div className="mb-3">
                          <Label className="form-label">
                            Número de documento
                          </Label>
                          <Input
                            name="numero_documento"
                            type="text"
                            placeholder="Enter document number"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.numero_documento || ""}
                            invalid={
                              validation.touched.numero_documento &&
                              validation.errors.numero_documento
                                ? true
                                : false
                            }
                          />
                          {validation.touched.numero_documento &&
                            validation.errors.numero_documento && (
                              <FormFeedback>
                                {validation.errors.numero_documento}
                              </FormFeedback>
                            )}
                        </div>

                        {/* social_number */}
                        <div className="mb-3">
                          <Label className="form-label">
                            Número Identificación Tributaria
                          </Label>
                          <Input
                            name="social_number"
                            type="text"
                            placeholder="Número Identificación Tributaria"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.social_number || ""}
                            invalid={
                              validation.touched.social_number &&
                              validation.errors.social_number
                                ? true
                                : false
                            }
                          />
                          {validation.touched.social_number &&
                            validation.errors.social_number && (
                              <FormFeedback>
                                {validation.errors.social_number}
                              </FormFeedback>
                            )}
                        </div>
                        {/* TODO - nrc */}
                        {entityType.map((entity: any) => {
                          if (entity.id === parseInt(userType)) {
                            if (entity.code === "EMP" || entity.code === "PER")
                              return (
                                <div className="mb-3">
                                  <Label className="form-label">NRC</Label>
                                  <Input
                                    id="nrc"
                                    name="nrc"
                                    className="form-control"
                                    placeholder="Enter nrc"
                                    type="text"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.nrc || ""}
                                    invalid={
                                      validation.touched.nrc &&
                                      validation.errors.nrc
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.nrc &&
                                    validation.errors.nrc && (
                                      <FormFeedback>
                                        {validation.errors.nrc}
                                      </FormFeedback>
                                    )}
                                </div>
                              );
                          }
                        })}
                        {/* email */}
                        <div className="mb-3">
                          <Label className="form-label">email</Label>
                          <Input
                            name="email"
                            type="text"
                            placeholder="Enter email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                            validation.errors.email && (
                              <FormFeedback>
                                {validation.errors.email}
                              </FormFeedback>
                            )}
                        </div>
                        {/* address */}
                        <div className="mb-3">
                          <Label className="form-label">Direccion</Label>
                          <Input
                            name="address"
                            type="text"
                            placeholder="Enter Address"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.address || ""}
                            invalid={
                              validation.touched.address &&
                              validation.errors.address
                                ? true
                                : false
                            }
                          />
                          {validation.touched.address &&
                            validation.errors.address && (
                              <FormFeedback>
                                {validation.errors.address}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>
                      {/* FIN DE LA COLUMNA DERECHA */}

                      {/* COMIENZA LA COLUMNA DEL LADO DERECHO */}
                      <Col sm={6}>
                        {/* Country */}
                        <div className="mb-3">
                          <Label className="form-label">Pais</Label>
                          <Input
                            type="select"
                            name="country"
                            onChange={(e) => {
                              handleApisCalls(e.target.value);
                              validation.handleChange(e);
                              validation.setFieldValue(
                                "state_country",
                                "",
                                true
                              );
                              validation.setFieldValue("currency_id", "", true);
                              validation.setFieldValue(
                                "economic_activities",
                                "",
                                true
                              );
                            }}
                            onBlur={validation.handleBlur}
                            value={validation.values.country || ""}
                            invalid={
                              validation.touched.country &&
                              validation.errors.country
                                ? true
                                : false
                            }
                          >
                            <option value="" selected disabled>
                              Select country
                            </option>
                            {countryType.map((country: any) => (
                              <option key={country.id} value={country.acronym}>
                                {country.name}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.country &&
                            validation.errors.country && (
                              <FormFeedback>
                                {validation.errors.country}
                              </FormFeedback>
                            )}
                        </div>
                        {/* TODO - phone with country code */}
                        <div className="mb-3">
                          <Label className="form-label">Phone</Label>
                          <div className="d-flex gap-2">
                            {/* Dropdown con códigos de países */}
                            <select
                              style={{ width: "150px" }}
                              name="countryCode"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              // value={""}
                              className="form-select w-[140px]"
                            >
                              {countryCodes.map((country) => (
                                <option key={country.id} value={country.code}>
                                  {country.abbr3} ({country.code})
                                </option>
                              ))}
                            </select>

                            {/* Input de teléfono */}
                            <Input
                              name="phone"
                              type="number"
                              placeholder="Enter phone"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.phone || ""}
                              invalid={
                                validation.touched.phone &&
                                validation.errors.phone
                                  ? true
                                  : false
                              }
                            />
                          </div>

                          {/* Validación */}
                          {validation.touched.phone &&
                            validation.errors.phone && (
                              <FormFeedback>
                                {validation.errors.phone}
                              </FormFeedback>
                            )}
                        </div>

                        {/* state_country */}
                        <div className="mb-3">
                          <Label className="form-label">
                            Estado/Departamento
                          </Label>
                          <Input
                            type="select"
                            name="state_country"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.state_country || ""}
                            invalid={
                              validation.touched.state_country &&
                              validation.errors.state_country
                                ? true
                                : false
                            }
                          >
                            <option value="" selected disabled>
                              Select State
                            </option>
                            {stateCountry.map((state: any) => (
                              <option key={state.id} value={state.id}>
                                {state.name}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.state_country &&
                            validation.errors.state_country && (
                              <FormFeedback>
                                {validation.errors.state_country}
                              </FormFeedback>
                            )}
                        </div>

                        {/* currency_id */}
                        <div className="mb-3">
                          <Label className="form-label">Moneda</Label>
                          <Input
                            type="select"
                            name="currency_id"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.currency_id || ""}
                            invalid={
                              validation.touched.currency_id &&
                              validation.errors.currency_id
                                ? true
                                : false
                            }
                          >
                            <option value="" selected disabled>
                              Select Currency
                            </option>
                            {currenType.map((currency: any) => (
                              <option key={currency.id} value={currency.id}>
                                {currency.name}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.currency_id &&
                            validation.errors.currency_id && (
                              <FormFeedback>
                                {validation.errors.currency_id}
                              </FormFeedback>
                            )}
                        </div>

                        {/* language_id */}
                        <div className="mb-3">
                          <Label className="form-label">Idioma</Label>
                          <Input
                            type="select"
                            name="language_id"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.language_id || ""}
                            invalid={
                              validation.touched.language_id &&
                              validation.errors.language_id
                                ? true
                                : false
                            }
                          >
                            <option value="" selected disabled>
                              Select Language
                            </option>
                            {languageType.map((language: any) => (
                              <option key={language.id} value={language.id}>
                                {language.name}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.language_id &&
                            validation.errors.language_id && (
                              <FormFeedback>
                                {validation.errors.language_id}
                              </FormFeedback>
                            )}
                        </div>

                        {/* economic_activities */}
                        <div className="mb-3">
                          <Label className="form-label">
                            Actividades Economicas
                          </Label>
                          <Input
                            type="select"
                            name="economic_activities"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.economic_activities || ""}
                            invalid={
                              validation.touched.economic_activities &&
                              validation.errors.economic_activities
                                ? true
                                : false
                            }
                          >
                            <option value="" selected disabled>
                              Select Economic Activity
                            </option>
                            {economicActivity.map((activity) => (
                              <option key={activity.id} value={activity.id}>
                                {activity.name}
                              </option>
                            ))}
                          </Input>
                          {validation.touched.economic_activities &&
                            validation.errors.economic_activities && (
                              <FormFeedback>
                                {validation.errors.economic_activities}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>

                      {/* FIN DE LA COLUMNA DERECHA */}
                    </Row>
                    <div className="mt-4">
                      <button
                        className="btn btn-primary btn-block "
                        type="submit"
                      >
                        Next
                      </button>
                    </div>

                    <div className="mt-4 text-center">
                      <p className="mb-0">
                        By registering you agree to the Ditobanx{" "}
                        <Link
                          to="https://ditobanx.com/terminos-y-condiciones/"
                          className="text-primary"
                        >
                          Terms of Use
                        </Link>
                      </p>
                    </div>
                  </Form>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Already have an account ?{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    {" "}
                    Login
                  </Link>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(EntityForm);
